import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const HelperText = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {Object} props
 * @param {any} props.children
 * @param {any} [props.className]
 * @param {boolean} [props.valid]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function HelperText({
  children,
  valid,
  className,
  ...props
}, ref) {
  const validClasses = "text-en-green";
  const invalidClasses = "text-en-red";

  const hasValidation = () => ![null, undefined].includes(valid);

  const validationStyle = () => {
    if (hasValidation()) {
      return valid ? validClasses : invalidClasses;
    }
  };

  const helperTextClasses = classNames(["text-xs"], validationStyle(), className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: helperTextClasses,
    ref: ref
  }, props), children);
});
HelperText.propTypes = {
  children: PropTypes.any,
  valid: PropTypes.bool,
  className: PropTypes.string
};